import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Communication, CommunicationsService } from '../../services/communications.service';
import { CondominiumService } from '../../services/condominium.service';

@Component({
    selector: 'app-communications-summary',
    templateUrl: './communications-summary.component.html',
    styleUrls: ['./communications-summary.component.sass'],
    standalone: false
})
export class CommunicationsSummaryComponent implements OnInit {
  communications: Communication[] = [];
  isLoading = true;
  error = false;
  condominiumId: number | null = null;

  constructor(
    private communicationsService: CommunicationsService,
    private condominiumService: CondominiumService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        this.loadCommunications();
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
  }

  loadCommunications(): void {
    if (!this.condominiumId) {
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.communicationsService.getCommunications(this.condominiumId, 0, 5).subscribe({
      next: (response) => {
        if (response.page.totalElements > 0) {
          this.communications = response._embedded?.communicationResponseDTOList || [];
        } else {
          this.communications = [];
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading communications:', error);
        this.error = true;
        this.isLoading = false;
      }
    });
  }
}
